import { css, useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";

import { Typography, useThemeProps } from "../../wsui/base";

import useFormField from "./useFormField";

export default function FormFieldLabel(props) {
  const theme = useTheme();
  props = useThemeProps({ props, name: "FormFieldLabel" });
  let {
    as = "label",
    typographyVariant = ["formLabel", "caption"],
    ...restProps
  } = props;
  const { id, label, name, required, hideLabel } = useFormField();
  const { t } = useTranslation();

  return (
    <Typography
      as={as}
      variant={typographyVariant}
      id={`${id}-label`}
      htmlFor={id}
      css={css`
        display: block;
        width: fit-content;
        ${hideLabel && theme.styleUtils.visuallyHidden}
      `}
      {...restProps}
    >
      {label || name}
      {!!required && (
        <span
          aria-hidden="true"
          css={css`
            color: ${theme.getColor("error.500")};
          `}
        >
          *
        </span>
      )}
    </Typography>
  );
}
